import { LoanType } from '../../../../../../../../../common/constants/LoanType';
import { StandardLoanDetails } from '../../../../../../queries/standardLoanQueries';
import { LoanForm, LoanStepContext } from '../constants/loanForm';
import { getDefaultInterestAccrualType } from './getDefaultInterestAccrualType';
import { getSameAsCommitted } from './getSameAsCommitted';

/**
 * The Loan step's form, "Same as Committed", files and context for a loaded loan, following EditStdLoanModal's
 * populateState. loanTypeId is the loan's, or the one the modal was opened with when a new-loan template doesn't say.
 */
export const getLoanFromLoan = (loan: StandardLoanDetails, loanTypeId: LoanType | undefined) => {
    const properties = loan.properties ?? [];

    // With more than one property, a non-Bridge loan's Apprvd Loan Amt is the sum of their commitments (Bridge loans
    // enter it by hand)
    const commitment =
        loanTypeId !== LoanType.Bridge && properties.length > 1
            ? properties.reduce((sum, property) => sum + (property.commitment ?? 0), 0)
            : (loan.commitment ?? undefined);

    const loanForm: LoanForm = {
        promissoryNote: loan.promissoryNote ?? undefined,
        commitment,
        bridgeFunded: loan.bridgeFunded ?? undefined,
        interestRate: loan.interestRate ?? undefined,
        interestAcrualTypeId:
            loan.interestAcrualTypeId != null && loan.interestAcrualTypeId >= 0
                ? loan.interestAcrualTypeId
                : getDefaultInterestAccrualType(loanTypeId),
        interestRateFloor: loan.interestRateFloor ?? undefined,
        interestRateCeiling: loan.interestRateCeiling ?? undefined,
        reserveRate: loan.reserveRate ?? undefined,
        grade: loan.grade ?? undefined,
        gradeReason: '',
        entireStructure: loan.entireStructure ?? undefined,
        underwritingFee: loan.underwritingFee ?? undefined,
        originationFee: loan.originationFee ?? undefined,
        brokerShare: loan.brokerShare ?? undefined,
        brokerAdditional: loan.brokerAdditional ?? undefined,
        liquidity: loan.liquidity ?? undefined,
    };

    const loanStepContext: LoanStepContext = {
        interestTypeId: loan.interestTypeId ?? undefined,
        savedGrade: loan.grade ?? undefined,
    };

    return {
        loan: loanForm,
        sameAsCommitted: getSameAsCommitted(loanTypeId, loanForm),
        loanFiles: loan.files ?? [],
        loanStepContext,
    };
};
